export const PrayingHands = ({ className = "w-4 h-4" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M11.6 3.4c0-.8-.6-1.4-1.4-1.4S8.8 2.6 8.8 3.4v5.4L6 12.6a2 2 0 0 0-.4 1.2v3.3c0 2.4 1.9 4.4 4.2 4.4h1.8V3.4Z" />
    <path d="M12.4 3.4c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v5.4L18 12.6c.3.4.4.8.4 1.2v3.3c0 2.4-1.9 4.4-4.2 4.4h-1.8V3.4Z" />
    <path d="M12 21.5V4" />
  </svg>
);

export default PrayingHands;
